import { render, staticRenderFns } from "./UiStringMidResult.vue?vue&type=template&id=1d53c140&scoped=true&"
import script from "./UiStringMidResult.vue?vue&type=script&lang=ts&"
export * from "./UiStringMidResult.vue?vue&type=script&lang=ts&"
import style0 from "./UiStringMidResult.vue?vue&type=style&index=0&id=1d53c140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d53c140",
  null
  
)

export default component.exports